<template>
  <el-dialog :close-on-click-modal="false" title="查看设计版" :visible.sync="isShow" width="800px">
    <el-table :data="tableData" style="width: 100%" border>
      <el-table-column prop="imageCount" sortable label="照片数量"></el-table-column>
      <el-table-column prop="id" label="编号"></el-table-column>
      <el-table-column prop="date" label="模板缩略图">
        <template slot-scope="scope">
          <templateThumbnail :templateGroup="scope.row" />
        </template>
      </el-table-column>
      <el-table-column prop="date" label="页面类型">
        <template slot-scope="scope"> {{ $config.pageType[scope.row.pageTypeCode] }} </template>
      </el-table-column>
    </el-table>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="isShow = false">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import templateThumbnail from '@/components/templateThumbnail.vue'
import { getTemplateGroupByModuleId } from '@/api/pms.js'
export default {
  components: {
    templateThumbnail
  },
  data () {
    return {
      isShow: false,
      tableData: []
    }
  },
  methods: {
    show (id) {
      this.isShow = true
      getTemplateGroupByModuleId(id)
        .then(res => {
          console.log(res)
          if (res.data.success) {
            let list = res.data.data

            list.forEach(item => {
              if (item.propertyId === 2) {
                item.templateThumbnailList = [item.templates[0].templateThumbnail]
              } else {
                item.templateThumbnailList = item.templates.reduce((list, temp) => {
                  list[temp.templatePosition] = temp.templateThumbnail
                  return list
                }, [])
              }
            })

            this.tableData = list
            console.log(list)
          }
        })
    }
  }
}
</script>

<style lang='less'>
.imgBox {
  width: 100%;
  display: flex;
  justify-content: space-around;

  .img {
    flex: 1;
  }
}
</style>
